/** Client for the search hub's cross-project search (GET /api/v1/search/). */
import { apiRequest } from "./client";
import type { TaskStatus } from "./tasks";

export type WorkspaceSearchKind = "tasks" | "frames" | "agents";

export interface WorkspaceTask {
  id: string;
  title: string;
  status: TaskStatus;
  ticket_display: string | null;
  project_id: string;
  project_name: string;
  assignee_name: string;
  assignee_kind: "coding_agent" | "agent" | "user" | "sub_agent" | "unassigned";
  needs_attention: boolean;
  created_at: string;
  updated_at: string;
}

export interface WorkspaceFrame {
  id: string;
  title: string;
  frame_type: string;
  project_id: string;
  project_name: string;
  updated_at: string;
}

export interface WorkspaceAgent {
  updated_at?: string;
  id: string;
  template_id: string;
  name: string;
  color: string;
  avatar_seed: string;
  project_id: string;
  project_name: string;
}

export interface WorkspaceSearchGroup<T> {
  items: T[];
  total: number;
}

export interface WorkspaceSearchResults {
  tasks?: WorkspaceSearchGroup<WorkspaceTask>;
  frames?: WorkspaceSearchGroup<WorkspaceFrame>;
  agents?: WorkspaceSearchGroup<WorkspaceAgent>;
}

interface ApiResponse<T> {
  status: "success";
  data: T;
}

export async function searchWorkspace(options: {
  query: string;
  projectId: string | null;
  kinds: readonly WorkspaceSearchKind[];
}): Promise<WorkspaceSearchResults> {
  const params = new URLSearchParams({
    q: options.query.trim(),
    kinds: options.kinds.join(","),
  });
  if (options.projectId) params.set("project_id", options.projectId);
  const res = await apiRequest<ApiResponse<WorkspaceSearchResults>>(
    `/api/v1/search/?${params.toString()}`,
    { method: "GET", silent: true },
  );
  return res.data;
}
